export enum BusinessLegalProtectionType {
  SWITZERLAND = 'SWITZERLAND',
  EUROPE = 'EUROPE',
  WORLD = 'WORLD',
}

export const getBusinessLegalProtectionTypeLabel = (
  type: BusinessLegalProtectionType
) => {
  switch (type) {
    case BusinessLegalProtectionType.SWITZERLAND:
      return $localize`CH/FL`;
    case BusinessLegalProtectionType.EUROPE:
      return $localize`UE/AELE/Europe`;
    case BusinessLegalProtectionType.WORLD:
      return $localize`Monde`;
  }
};
